/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link, Text, View } from '@react-pdf/renderer';
import styles from '../pro-report-pdf-styles';

function Feedback() {
  return (
    <View style={styles.section}>
      <Text style={styles.textBold}>Your opinion matters!</Text>
      <Text>
        Please take 5 minutes to provide feedback on the PRO Report’s content{' '}
        <Link
          src="https://forms.cloud.microsoft/pages/responsepage.aspx?id=JoOfHD15akSsgCmczmU8LnwTuysRMqREl7ffQO8Gk-hUOEFGTEVEMzc1Nk0zWUc5TDg0MDVOM05QUy4u&route=shorturl"
          style={styles.link}
        >
          here
        </Link>
        .
      </Text>
    </View>
  );
}

export default Feedback;
